import script from "./UpgradePlanWithoutPermission.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpgradePlanWithoutPermission.vue?vue&type=script&setup=true&lang=ts"

import "./UpgradePlanWithoutPermission.vue?vue&type=style&index=0&id=629f581b&lang=scss"

const __exports__ = script;

export default __exports__